
import React, {useContext, useRef, useState, useEffect} from "react";
import classnames from "classnames";
import {
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Row,
    Col,
    CardHeader,
    Card,
    CardBody,
    Button,
    FormGroup,
    Label
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import { UserLoginContext } from "../../context/UserLoginContext";
import { EventsContext } from "../../context/EventsContext";
import { QuestionsContext } from "../../context/QuestionsContext";
import {useHistory} from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import rest from "../../API/api";
import { authenticatedFetch } from "../../services/authService";
import ReactTable from "components/ReactTable/ReactTable.js";

const AddEvent = () => {
    const [eventsState, setEventsState] = useContext(EventsContext);
    const [userState, setUserState] = useContext(UserLoginContext);
    const [questionsState, setQuestionsState] = useContext(QuestionsContext);
    const notificationAlertRef = useRef(null);
    const fileInputRef = useRef(null);
    const history = useHistory();

    // Basic Event Information
    const [enabled, setEnabled] = useState(false);
    const [title, setTitle] = useState("");
    const [titleState, setTitleState] = useState("");
    const [subTitle, setSubTitle] = useState("");
    const [subTitleState, setSubTitleState] = useState("");
    const [description, setDescription] = useState("");
    const [descriptionState, setDescriptionState] = useState("");
    const [type, setType] = useState("");
    const [typeState, setTypeState] = useState("");
    const [contact, setContact] = useState("");
    const [contactState, setContactState] = useState("");
    const [phone, setPhone] = useState("");
    const [phoneState, setPhoneState] = useState("");
    const [email, setEmail] = useState("");
    const [emailState, setEmailState] = useState("");
    const [location, setLocation] = useState("");
    const [locationState, setLocationState] = useState("");
    const [price, setPrice] = useState(0);
    const [maxRegistrations, setMaxRegistrations] = useState(8);
    const [otherWebsite, setOtherWebsite] = useState("");
    const [image, setImage] = useState("");
    const [imagePublicId, setImagePublicId] = useState("");

    // Event Scheduling
    const [startDate, setStartDate] = useState("");
    const [startDateState, setStartDateState] = useState("");
    const [endDate, setEndDate] = useState("");
    const [endDateState, setEndDateState] = useState("");
    const [ageRestriction, setAgeRestriction] = useState("");
    const [ageRestrictionState, setAgeRestrictionState] = useState("");
    const [genderRestriction, setGenderRestriction] = useState("");
    const [genderRestrictionState, setGenderRestrictionState] = useState("");
    const [youngerThan, setYoungerThan] = useState("No Restriction");

    // Event Requirements
    const [acceptOnlineRegistration, setAcceptOnlineRegistration] = useState(false);
    const [requireWaivers, setRequireWaivers] = useState(false);
    const [requireNameEmail, setRequireNameEmail] = useState(false);
    const [requireDOB, setRequireDOB] = useState(false);
    const [requireGender, setRequireGender] = useState(false);
    const [requirePhone, setRequirePhone] = useState(false);
    const [includeQuestions, setIncludeQuestions] = useState(false);
    const [afterSubmit, setAfterSubmit] = useState("");
    const [afterSubmitState, setAfterSubmitState] = useState("");

    // Questions
    const [dataQuestions, setDataQuestions] = useState([]);
    const [alert, setAlert] = useState(null);

    // Load questions on mount
    useEffect(() => {
        const loadQuestions = async () => {
            try {
                let tempURL = rest.questions;
                const questionsResponse = await authenticatedFetch(tempURL, {
                    method: 'GET'
                });

                if (!questionsResponse.ok) {
                    console.error('Failed to fetch questions');
                    return;
                }

                const questionsData = await questionsResponse.json();

                // Map questions with action buttons
                const mappedQuestions = questionsData.map(question => ({
                    id: question._id,
                    Title: question.Title,
                    Question: question.Question,
                    Type: question.Type,
                    Included: "Not Included",
                    actions: (
                        <div className="actions-right">
                            <Button
                                onClick={() => toggleQuestionInclusion(question._id, "Included")}
                                color="info"
                                size="sm"
                                className="btn-icon btn-link"
                            >
                                <i className="tim-icons icon-simple-add"/>
                            </Button>{" "}
                            <Button
                                onClick={() => toggleQuestionInclusion(question._id, "Not Included")}
                                color="danger"
                                size="sm"
                                className="btn-icon btn-link"
                            >
                                <i className="tim-icons icon-simple-remove"/>
                            </Button>
                        </div>
                    )
                }));

                setDataQuestions(mappedQuestions);
            } catch (error) {
                console.error('Error loading questions:', error);
            }
        };

        if (userState.status) {
            loadQuestions();
        }
    }, [userState.status]);

    const toggleQuestionInclusion = (questionId, status) => {
        setDataQuestions(prevQuestions =>
            prevQuestions.map(q => {
                if (q.id === questionId) {
                    return {
                        ...q,
                        Included: status,
                        actions: (
                            <div className="actions-right">
                                <Button
                                    onClick={() => toggleQuestionInclusion(questionId, "Included")}
                                    color="info"
                                    size="sm"
                                    className="btn-icon btn-link"
                                >
                                    <i className="tim-icons icon-simple-add"/>
                                </Button>{" "}
                                <Button
                                    onClick={() => toggleQuestionInclusion(questionId, "Not Included")}
                                    color="danger"
                                    size="sm"
                                    className="btn-icon btn-link"
                                >
                                    <i className="tim-icons icon-simple-remove"/>
                                </Button>
                            </div>
                        )
                    };
                }
                return q;
            })
        );
    };

    const notify = (type, message) => {
        const options = {
            place: "tc",
            message: <div>{message}</div>,
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    const verifyLength = (value, length) => {
        return value.length >= length;
    };

    const verifyEmail = (value) => {
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailRex.test(value);
    };

    // Phone number formatting
    const normalizePhone = (value, previousValue) => {
        if (!value) return value;
        const currentValue = value.replace(/[^\d]/g, '');
        const cvLength = currentValue.length;

        if (!previousValue || value.length > previousValue.length) {
            if (cvLength < 4) return currentValue;
            if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
            return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
        }
        return value;
    };

    const handlePhoneChange = (e) => {
        const newValue = normalizePhone(e.target.value, phone);
        setPhone(newValue);

        // Validate phone
        if (newValue && newValue.length === 14) {
            setPhoneState("has-success");
        } else if (newValue === "") {
            setPhoneState("has-success");
        } else {
            setPhoneState("has-danger");
        }
    };

    const handleFileChange = (event) => {
        event.preventDefault();
        let reader = new FileReader();
        let file = event.target.files[0];

        if (file) {
            reader.onloadend = () => {
                setImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const isValidated = () => {
        let valid = true;

        // Title validation
        if (!verifyLength(title, 1)) {
            setTitleState("has-danger");
            valid = false;
        } else {
            setTitleState("has-success");
        }

        // SubTitle validation
        if (!verifyLength(subTitle, 1)) {
            setSubTitleState("has-danger");
            valid = false;
        } else {
            setSubTitleState("has-success");
        }

        // Description validation
        if (!verifyLength(description, 1)) {
            setDescriptionState("has-danger");
            valid = false;
        } else {
            setDescriptionState("has-success");
        }

        // Type validation
        if (!type || type === "" || type === "What type of event is this?") {
            setTypeState("has-danger");
            valid = false;
        } else {
            setTypeState("has-success");
        }

        // Contact validation
        if (!verifyLength(contact, 1)) {
            setContactState("has-danger");
            valid = false;
        } else {
            setContactState("has-success");
        }

        // Phone validation
        if (phone && phone.length !== 14) {
            setPhoneState("has-danger");
            valid = false;
        } else if (!phone || phone === "") {
            setPhoneState("has-danger");
            valid = false;
        } else {
            setPhoneState("has-success");
        }

        // Email validation
        if (!verifyEmail(email)) {
            setEmailState("has-danger");
            valid = false;
        } else {
            setEmailState("has-success");
        }

        // Location validation
        if (!verifyLength(location, 1)) {
            setLocationState("has-danger");
            valid = false;
        } else {
            setLocationState("has-success");
        }

        // Start Date validation
        if (!startDate || startDate === "") {
            setStartDateState("has-danger");
            valid = false;
        } else {
            setStartDateState("has-success");
        }

        // End Date validation
        if (!endDate || endDate === "") {
            setEndDateState("has-danger");
            valid = false;
        } else {
            setEndDateState("has-success");
        }

        // Age Restriction validation
        if (!ageRestriction || ageRestriction === "" || ageRestriction === "What are the Event Age Restrictions?") {
            setAgeRestrictionState("has-danger");
            valid = false;
        } else {
            setAgeRestrictionState("has-success");
        }

        // Gender Restriction validation
        if (!genderRestriction || genderRestriction === "" || genderRestriction === "What are the Event Gender Restrictions?") {
            setGenderRestrictionState("has-danger");
            valid = false;
        } else {
            setGenderRestrictionState("has-success");
        }

        // After Submit validation
        if (!afterSubmit || afterSubmit === "" || afterSubmit === "Where do we go after submit?") {
            setAfterSubmitState("has-danger");
            valid = false;
        } else {
            setAfterSubmitState("has-success");
        }

        return valid;
    };

    const _addEventAlert = async () => {
        if (!isValidated()) {
            notify("danger", "Please fill in all required fields correctly!");
            return;
        }

        setAlert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Yes, save it!"
                confirmBtnBsStyle="info"
                cancelBtnBsStyle="default"
                title="Are you sure?"
                style={{display: "block"}}
                onConfirm={() => {
                    _add_event();
                    setAlert(null);
                }}
                onCancel={() => {
                    setAlert(null);
                }}
            >
                Are you sure you want to save this event?
            </SweetAlert>
        );
    };

    const _add_event = async () => {
        try {
            // Gather included questions
            const includedQuestions = dataQuestions
                .filter(q => q.Included === "Included")
                .map(q => ({
                    QuestionsId: q.id,
                    Question: q.Question,
                    Type: q.Type,
                    Title: q.Title,
                    Included: q.Included,
                    Required: false
                }));

            const eventData = {
                Enabled: enabled,
                Title: title,
                Image: image,
                ImagePublicId: imagePublicId,
                SubTitle: subTitle,
                Description: description,
                Type: type,
                Contact: contact,
                Phone: phone,
                Email: email,
                OtherWebsite: otherWebsite,
                Location: location,
                StartDate: startDate,
                EndDate: endDate,
                AgeRestriction: ageRestriction,
                GenderRestriction: genderRestriction,
                YoungerThan: youngerThan,
                AfterSubmit: afterSubmit,
                RequireWaivers: requireWaivers,
                RequireNameEmail: requireNameEmail,
                RequireDOB: requireDOB,
                RequireGender: requireGender,
                RequirePhone: requirePhone,
                IncludeQuestions: includeQuestions,
                IncludedQuestions: includedQuestions,
                AcceptOnlineRegistration: acceptOnlineRegistration,
                Price: price,
                MaxRegistrations: maxRegistrations
            };

            var tempURL = rest.events;
            const addEvent = await authenticatedFetch(tempURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                body: JSON.stringify(eventData),
            });

            if (!addEvent.ok) {
                throw new Error('Failed to add event');
            }

            const addEventJSON = await addEvent.json();
            setEventsState((prevEventsState) => ({
                ...prevEventsState,
                theEvents: addEventJSON
            }));

            notify("success", "Event has been added successfully!");
            setTimeout(() => {
                history.push("/admin/events");
            }, 1000);
        } catch (error) {
            console.error('Error adding event:', error);
            notify("danger", error.message || 'Failed to add event.');
        }
    };

    if (!userState.status) {
        history.push("/admin/dashboard");
        return null;
    }

    return (
        <>
            <div className="rna-container">
                <NotificationAlert ref={notificationAlertRef} />
            </div>
            <div className="content">
                <Col md={10} className="ml-auto mr-auto">
                    <h2 className="text-center">Add Event</h2>
                    <p className="text-center">
                        Create a new event with registration capabilities
                    </p>
                </Col>

                {/* Basic Event Information */}
                <Card>
                    <CardHeader>
                        <h5 className="title">Basic Event Information</h5>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={2}>
                                <FormGroup>
                                    <Label>Enabled</Label>
                                    <div>
                                        <label className="custom-toggle">
                                            <input
                                                type="checkbox"
                                                checked={enabled}
                                                onChange={(e) => setEnabled(e.target.checked)}
                                            />
                                            <span className="custom-toggle-slider rounded-circle" />
                                        </label>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup className={`has-label ${titleState}`}>
                                    <label>Event Title <span className="text-danger">*</span></label>
                                    <Input
                                        name="title"
                                        type="text"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                        placeholder="My Event Title"
                                    />
                                    {titleState === "has-danger" && (
                                        <label className="error">Please enter a valid event title.</label>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className={`has-label ${subTitleState}`}>
                                    <label>Event Sub-Title <span className="text-danger">*</span></label>
                                    <Input
                                        name="subtitle"
                                        type="text"
                                        value={subTitle}
                                        onChange={(e) => setSubTitle(e.target.value)}
                                        placeholder="My Event Sub-Title"
                                    />
                                    {subTitleState === "has-danger" && (
                                        <label className="error">Please enter a valid sub-title.</label>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className={`has-label ${descriptionState}`}>
                                    <label>Event Description <span className="text-danger">*</span></label>
                                    <Input
                                        name="description"
                                        type="text"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        placeholder="My Event Description"
                                    />
                                    {descriptionState === "has-danger" && (
                                        <label className="error">Please enter a valid description.</label>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup className={`has-label ${typeState}`}>
                                    <label>Event Type <span className="text-danger">*</span></label>
                                    <Input
                                        type="select"
                                        value={type}
                                        onChange={(e) => setType(e.target.value)}
                                    >
                                        <option value="">What type of event is this?</option>
                                        <option value="Camp">Camp</option>
                                        <option value="Class">Class</option>
                                        <option value="Club">Club</option>
                                        <option value="Event">Event</option>
                                        <option value="League">League</option>
                                        <option value="Tourney">Tourney</option>
                                        <option value="Training">Training</option>
                                    </Input>
                                    {typeState === "has-danger" && (
                                        <label className="error">Please select an event type.</label>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup className={`has-label ${contactState}`}>
                                    <label>Event Contact <span className="text-danger">*</span></label>
                                    <Input
                                        name="contact"
                                        type="text"
                                        value={contact}
                                        onChange={(e) => setContact(e.target.value)}
                                        placeholder="Contact Name"
                                    />
                                    {contactState === "has-danger" && (
                                        <label className="error">Please enter a contact name.</label>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className={`has-label ${phoneState}`}>
                                    <label>Contact Phone <span className="text-danger">*</span></label>
                                    <Input
                                        name="phone"
                                        type="text"
                                        value={phone}
                                        onChange={handlePhoneChange}
                                        placeholder="ex: (303) 867-5309"
                                    />
                                    {phoneState === "has-danger" && (
                                        <label className="error">Invalid phone format. ex: (303) 867-5309</label>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className={`has-label ${emailState}`}>
                                    <label>Contact Email <span className="text-danger">*</span></label>
                                    <Input
                                        name="email"
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="email@example.com"
                                    />
                                    {emailState === "has-danger" && (
                                        <label className="error">Please enter a valid email address.</label>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup className={`has-label ${locationState}`}>
                                    <label>Event Location <span className="text-danger">*</span></label>
                                    <Input
                                        name="location"
                                        type="text"
                                        value={location}
                                        onChange={(e) => setLocation(e.target.value)}
                                        placeholder="Event Address"
                                    />
                                    {locationState === "has-danger" && (
                                        <label className="error">Please enter a location.</label>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <label>Event Price</label>
                                    <Input
                                        name="price"
                                        type="number"
                                        value={price}
                                        onChange={(e) => setPrice(e.target.value)}
                                        placeholder="0"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <label>Max Registrations</label>
                                    <Input
                                        name="maxRegistrations"
                                        type="number"
                                        value={maxRegistrations}
                                        onChange={(e) => setMaxRegistrations(e.target.value)}
                                        placeholder="8"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={8}>
                                <FormGroup>
                                    <label>Other Website URL</label>
                                    <Input
                                        name="otherWebsite"
                                        type="text"
                                        value={otherWebsite}
                                        onChange={(e) => setOtherWebsite(e.target.value)}
                                        placeholder="https://..."
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <label className="custom-control custom-checkbox">
                                        <input
                                            className="custom-control-input"
                                            type="checkbox"
                                            checked={acceptOnlineRegistration}
                                            onChange={(e) => setAcceptOnlineRegistration(e.target.checked)}
                                        />
                                        <span className="custom-control-label">
                                            Accept Online Registrations
                                        </span>
                                    </label>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <label className="custom-control custom-checkbox">
                                        <input
                                            className="custom-control-input"
                                            type="checkbox"
                                            checked={requireWaivers}
                                            onChange={(e) => setRequireWaivers(e.target.checked)}
                                        />
                                        <span className="custom-control-label">
                                            Require Waivers
                                        </span>
                                    </label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup className={`has-label ${afterSubmitState}`}>
                                    <label>After Submit <span className="text-danger">*</span></label>
                                    <Input
                                        type="select"
                                        value={afterSubmit}
                                        onChange={(e) => setAfterSubmit(e.target.value)}
                                    >
                                        <option value="">Where do we go after submit?</option>
                                        <option value="Same">Refresh - Stay on this form</option>
                                        <option value="Index">Show list of your events</option>
                                    </Input>
                                    {afterSubmitState === "has-danger" && (
                                        <label className="error">Please select an after-submit action.</label>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <label>Event Image</label>
                                    <input
                                        style={{display: 'none'}}
                                        type="file"
                                        onChange={handleFileChange}
                                        ref={fileInputRef}
                                        accept="image/*"
                                    />
                                    <div>
                                        <Button
                                            color="info"
                                            onClick={() => fileInputRef.current.click()}
                                        >
                                            Pick an Image
                                        </Button>
                                    </div>
                                </FormGroup>
                            </Col>
                            {image && (
                                <Col md={4}>
                                    <FormGroup>
                                        <label>Preview</label>
                                        <div>
                                            <img src={image} alt="Preview" style={{maxWidth: '100%', maxHeight: '200px'}} />
                                        </div>
                                    </FormGroup>
                                </Col>
                            )}
                        </Row>
                    </CardBody>
                </Card>

                {/* Event Scheduling */}
                <Card>
                    <CardHeader>
                        <h5 className="title">Event Scheduling</h5>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={4}>
                                <FormGroup className={`has-label ${startDateState}`}>
                                    <label>Start Date/Time <span className="text-danger">*</span></label>
                                    <Input
                                        name="startDate"
                                        type="datetime-local"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                    {startDateState === "has-danger" && (
                                        <label className="error">Please enter a start date.</label>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className={`has-label ${endDateState}`}>
                                    <label>End Date/Time <span className="text-danger">*</span></label>
                                    <Input
                                        name="endDate"
                                        type="datetime-local"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                    {endDateState === "has-danger" && (
                                        <label className="error">Please enter an end date.</label>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup className={`has-label ${ageRestrictionState}`}>
                                    <label>Age Restrictions <span className="text-danger">*</span></label>
                                    <Input
                                        type="select"
                                        value={ageRestriction}
                                        onChange={(e) => setAgeRestriction(e.target.value)}
                                    >
                                        <option value="">What are the Event Age Restrictions?</option>
                                        <option value="Adults">Adults (18+)</option>
                                        <option value="Youth">Youth (under 18)</option>
                                        <option value="Teens">Teens (13-17)</option>
                                        <option value="Masters">Master (Over 40)</option>
                                        <option value="Seniors">Seniors (Over 50)</option>
                                    </Input>
                                    {ageRestrictionState === "has-danger" && (
                                        <label className="error">Please select age restrictions.</label>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className={`has-label ${genderRestrictionState}`}>
                                    <label>Gender Restrictions <span className="text-danger">*</span></label>
                                    <Input
                                        type="select"
                                        value={genderRestriction}
                                        onChange={(e) => setGenderRestriction(e.target.value)}
                                    >
                                        <option value="">What are the Event Gender Restrictions?</option>
                                        <option value="Coed">Coed</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                    </Input>
                                    {genderRestrictionState === "has-danger" && (
                                        <label className="error">Please select gender restrictions.</label>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <label>Younger Than Restrictions</label>
                                    <Input
                                        type="select"
                                        value={youngerThan}
                                        onChange={(e) => setYoungerThan(e.target.value)}
                                    >
                                        <option value="No Restriction">No Restriction</option>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                        <option value="40">40</option>
                                        <option value="50">50</option>
                                        <option value="60">60</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* Event Questions */}
                <Card>
                    <CardHeader>
                        <h5 className="title">Event Questions</h5>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <label className="custom-control custom-checkbox">
                                        <input
                                            className="custom-control-input"
                                            type="checkbox"
                                            checked={requireNameEmail}
                                            onChange={(e) => setRequireNameEmail(e.target.checked)}
                                        />
                                        <span className="custom-control-label">
                                            Require Name and Email
                                        </span>
                                    </label>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <label className="custom-control custom-checkbox">
                                        <input
                                            className="custom-control-input"
                                            type="checkbox"
                                            checked={requireDOB}
                                            onChange={(e) => setRequireDOB(e.target.checked)}
                                        />
                                        <span className="custom-control-label">
                                            Require Date of Birth
                                        </span>
                                    </label>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <label className="custom-control custom-checkbox">
                                        <input
                                            className="custom-control-input"
                                            type="checkbox"
                                            checked={requireGender}
                                            onChange={(e) => setRequireGender(e.target.checked)}
                                        />
                                        <span className="custom-control-label">
                                            Require Gender
                                        </span>
                                    </label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <label className="custom-control custom-checkbox">
                                        <input
                                            className="custom-control-input"
                                            type="checkbox"
                                            checked={requirePhone}
                                            onChange={(e) => setRequirePhone(e.target.checked)}
                                        />
                                        <span className="custom-control-label">
                                            Require Phone Number
                                        </span>
                                    </label>
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <label className="custom-control custom-checkbox">
                                        <input
                                            className="custom-control-input"
                                            type="checkbox"
                                            checked={includeQuestions}
                                            onChange={(e) => setIncludeQuestions(e.target.checked)}
                                        />
                                        <span className="custom-control-label">
                                            Include Additional Questions
                                        </span>
                                    </label>
                                </FormGroup>
                            </Col>
                        </Row>
                        {includeQuestions && dataQuestions.length > 0 && (
                            <Row>
                                <Col md={12}>
                                    <ReactTable
                                        data={dataQuestions}
                                        filterable
                                        columns={[
                                            {
                                                Header: "Title",
                                                accessor: "Title"
                                            },
                                            {
                                                Header: "Question",
                                                accessor: "Question"
                                            },
                                            {
                                                Header: "Included in Form",
                                                accessor: "Included"
                                            },
                                            {
                                                Header: "Actions",
                                                accessor: "actions",
                                                sortable: false,
                                                filterable: false
                                            }
                                        ]}
                                        defaultPageSize={5}
                                        showPaginationTop
                                        showPaginationBottom={false}
                                        className="-striped -highlight"
                                    />
                                </Col>
                            </Row>
                        )}
                    </CardBody>
                </Card>

                {/* Save/Cancel Buttons */}
                <Card>
                    <CardBody>
                        <Row>
                            <Col md={2}>
                                <Button
                                    color="info"
                                    className="animation-on-hover"
                                    onClick={_addEventAlert}
                                    block
                                >
                                    Save Event
                                </Button>
                            </Col>
                            <Col md={2}>
                                <Button
                                    color="danger"
                                    className="animation-on-hover"
                                    onClick={() => history.push("/admin/events")}
                                    block
                                >
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                {alert}
            </div>
        </>
    );
};

export default AddEvent;
